// @flow
import defaultState from '../defaultState';
import type { UpdateCustomers as Action, Customer } from '../types';

const defaultCustomers = defaultState.customers;

export default function customers(
  state: Customer[] = defaultCustomers,
  action: Action
) {
  switch (action.type) {
    case 'UPDATE_CUSTOMERS':
      return action.customers;

    // $FlowFixMe
    case 'LOGOUT':
      return defaultCustomers;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/customers.js